import { useTranslation } from 'react-i18next'

export const NoAccessPage = () => {
  const { t } = useTranslation()
  return (
    <main className="grid h-full flex-auto place-items-center bg-surface px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <p className="font-semibold text-accent">403</p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight sm:text-5xl">
          {t('pages.noAccessTitle')}
        </h1>
        <p className="mt-6 leading-7 text-text-secondary">{t('pages.noAccessMessage')}</p>
      </div>
    </main>
  )
}
